export default function XML_RDF() {
  return (
    <div>
      <h1>XML_RDF</h1>
      <p>This is the XML_RDF component.</p>
    </div>
  );
}